import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </span>
            <span className={`text-xl font-bold font-heading transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              汗汗漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 cursor-pointer hover:text-primary-600 ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/' ? 'text-primary-500' : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 cursor-pointer hover:text-primary-600 ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname.startsWith('/category') ? 'text-primary-500' : ''}`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 cursor-pointer hover:text-primary-600 ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/about' ? 'text-primary-500' : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 text-sm pl-9 pr-3 py-2 rounded-full bg-background-100 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">首页</Link>
            <Link to="/category/all" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">分类浏览</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">关于我们</Link>
            <div className="relative mt-1">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full text-sm pl-9 pr-3 py-2 rounded-full bg-background-100 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}